import React, { useContext } from 'react';
import styled from 'styled-components';
import { ConfigurationContext } from '../../context';
import LabelCustom from '../elements/LabelCustom';
import ValidateID from '../elements/ValidateID';

const WrapperStyled = styled.div`
    order: ${props => props.order};
    >.inner{
        position: relative;
        display: flex;
        >.prefix{
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: lightgray;
            font-size: 14px;
            line-height: 14px;
            font-weight: 600;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
            padding: 0 10px;
        }
        >.icon{
            top: 11px;
            left: 10px;
            font-size: 23px;
            position: absolute;
            color: #645FF9;
        }
        input{
            position: relative;
            background-color: ${props => props.styles.background_color};
            border: 1px solid ${props => props.styles.border_color};
            border-radius: 6px;
            padding-left: ${props => props.icon ? "40px" : "10px" };
            padding-right: ${props => props.icon ? "40px" : "10px" };
            padding-top: 11px;
            padding-bottom: 11px;
            max-height: 44px;
            color: #484D63;
            font-size: 16px;
            &.with-prefix{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            :focus{
                outline: none !important;
                border-color: ${props => `rgb(${props.panColors.dots})`};
            }
            &[type="checkbox"]{
                width: 18px;
                height: 18px;
            }
            :disabled{
                opacity: 0.5;
            }
        }
    }
    >.help{
        font-size: 14px;
        margin-top: 5px;
        font-weight: 700;
        color: ${props => `rgb(${props.panColors.dark_gray})`};
        &.error{
            color: ${props => `rgb(${props.panColors.red})`};
        }
    }
    &.error{
        input{
            border: 2px solid ${props => `rgb(${props.panColors.red})`};
            :focus{
                outline: none !important;
                border-color: ${props => `rgb(${props.panColors.red})`};
            }
        }
    }
`

const InputCustom = (props) => {

    const { panColors } = useContext(ConfigurationContext);

    const { prefix = null,
            order, 
            name,
            label,
            onChange,
            onKeyDown,
            onKeyUp,
            className,
            type,
            value,
            help,
            placeholder,
            icon = null,
            label_icon = null,
            styles = null,
            disabled = false,
            isRequired = false,
            tooltip_content = null,
            haveError = null,
            validateStatus = null,
            setValidateStatus = null,
            index = null } = props;
    
    return (
        <WrapperStyled 
            panColors={panColors}
            styles={styles}
            className={className} 
            icon={icon ? true : false}
            order={order}
        >
            
            { label ? 
                <LabelCustom 
                    name={name}
                    label={label}
                    styles={styles}
                    label_icon={label_icon}
                    isRequired={isRequired}
                    tooltip_content={tooltip_content}
                />
            : "" }

            <div className="inner">
                
                {name === "user_login" && <ValidateID status={validateStatus} setStatus={setValidateStatus} />}
                { prefix ? <div className="prefix">{prefix}</div> : "" }
                <input 
                    className={`${prefix ? "with-prefix" : ""}`}
                    type={type} 
                    name={name} 
                    id={name} 
                    value={value ? value : ""}
                    onChange={(e) => onChange ? onChange(name, e.target.value, index, e.keyCode) : null}
                    onKeyDown={(e) => onKeyDown ? onKeyDown(e.key, name, e.target.value) : null}
                    onKeyUp={(e) => onKeyUp ? onKeyUp(e, name, e.target.value) : null}
                    placeholder={placeholder}
                    disabled={disabled}
                />

                {icon ? 
                <div className="icon">
                    {icon}
                </div>
                : ""
                }
            </div>

            { help ? <div className={`help${haveError ? " error" : ""}`}>{help}</div> : "" }

        </WrapperStyled>

    )

}

export default InputCustom;